import { formatDate } from '@angular/common';

export function formatCustomDate(date: Date, customFormat?: string) {
  return formatDate(date, customFormat || 'yyyy-MM-dd', 'es');
}
